/*
** DO NOT EDIT THIS FILE! All changes will be overwritten.
** edit the master in app/javascript/themes/snowplows/_snowplows_theme.js,
** then run script/activate-theme snowplows
*/

//
//    ####   #    #   ####   #    #  #####   #        ####   #    #   ####
//   #       ##   #  #    #  #    #  #    #  #       #    #  #    #  #
//    ####   # #  #  #    #  #    #  #    #  #       #    #  #    #   ####
//        #  #  # #  #    #  # ## #  #####   #       #    #  # ## #       #
//   #    #  #   ##  #    #  ##  ##  #       #       #    #  ##  ##  #    #
//    ####   #    #   ####   #    #  #       ######   ####   #    #   ####
//
// This file is installed into config/javascript/canyoneroTheme.js
// run script/activate-theme after making any changes

export const SITE_CONFIG = {
  siteName: 'snowplows',
  theme: {
    siteName: 'snowplows',
    displayName: "Snowplows Direct",
    saveCartLogo: "",
    pathPrefix: "", // for LocalUrlMaker
    mailingListName: "SnowPlow Insiders Mailing List",
    freeShipping: true,
  },
  classLists: {
    'CheckoutButton.main': [
      'bg-brand-primary hover:bg-brand-primary/80 !text-anti-primary',
      'border-b-2 border-blue-700 hover:border-blue-300'
    ]
  }
}


/*
** config/javascript/canyoneroTheme.js
** installed by ./script/activate-theme snowplows
** at Wed Nov  5 06:15:46 PM UTC 2025 on misterplow03
*/
